<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-2">
                  <h5 class="mb-0">Sub Menu</h5>
                </div>
                <div class="col-8">
                  <input v-model="table.search" class="form-control rounded-pill text-center" type="text" placeholder="Search Sub Menu" @keyup="filter"/>
                </div>
              </div>
            </div>
            <div class="table-responsive" style="height: 500px">
              <div class="table-responsive">
                <table v-if="!table.onLoad" class="table table-flush">
                  <thead class="table-primary">
                    <tr>
                      <!-- <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                        Menu &nbsp;
                      </th> -->
                      <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                        Sub Menu &nbsp;
                      </th>
                      <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                        Status &nbsp;
                      </th>
                      <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                        Created By &nbsp;
                      </th>
                      <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                        Created At &nbsp;
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="table.data.length > 0" class="table-scroll">
                    <tr v-for="submenu in table.data" :key="submenu.id">
                      <!-- <td class="text-sm py-3 px-4">
                        <div>{{ submenu.menus.menu_name }}</div>
                      </td> -->
                      <td class="text-sm py-3 px-4 font-weight-bolder">
                        <div>{{ submenu.name }}</div>
                      </td>
                      <td class="text-sm py-3 px-4">
                        <div>
                          <ArgonSwitch
                            :id="submenu.name"
                            :name="submenu.name"
                            :checked="submenu.status === 'active'"
                            disabled
                            @change="updateStatus(submenu)"
                          />
                        </div>
                      </td>
                      <td class="text-sm py-3 px-4">{{ submenu.created_by }}</td>
                      <td class="text-sm py-3 px-4">
                        {{ formatDate(submenu.created_at) }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="text-center"><td colspan="7">No Data</td></tr>
                  </tbody>
                </table>
                <SkeletonLoading
                  v-else
                  class="px-4 pt-5"
                  :shapes="[
                    { type: 'line', width: '100%', height: '20px' },
                    { type: 'line', width: '80%', height: '20px' },
                    { type: 'line', width: '60%', height: '20px' },
                  ]"
                />
              </div>
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination v-model="table.page.current_pages" :page-count="table.page.total_pages" size="sm" @click="changePage()"/>
              </span>
              <span class="float-end">
                {{ ((table.page.current_pages - 1) * table.page.per_pages) + table.data.length }} of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subMenuService from "@/services/generalSettings/subMenuService.js";
import BasePagination from "@/components/BasePagination.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";

import SkeletonLoading from "@/components/SkeletonLoading.vue";
import moment from "moment";
import api from '@/helpers/api';
import { mapActions } from "vuex";
moment.locale("id");

export default {
  components: {
    BasePagination,
    ArgonSwitch,
    SkeletonLoading,
  },
  data() {
    return {
      loadTimeout: null,  
      table: {
        onLoad: true,
        search: this.$route.query.search ? this.$route.query.search : '',                    
        total: 0,
        data: [],
        page: {
            current_pages: 1,
        },
      },
    };
  },
  computed: {
  },
  mounted() {
    this.fetchSubMenus();
  },
  methods: {
    ...mapActions("auth", ["updateStatMenuOrSubMenu"]),
    async fetchSubMenus() {
      this.table.onLoad = true;

      try {
        const response = await api(this, subMenuService.list(this.table.page.current_pages, {search: this.table.search}), false);
        this.table.data  = response.data;  
        this.table.total = response.total_items;
        this.table.page  = response;  

      } catch (error) {
        this.table.data  = [];     
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    async updateStatus(submenu) {
      this.table.onLoad = true

      try {
        await api(this, subMenuService.updateStatus(submenu))
        const type = "submenu"; // update status menu di vuex
        const value = submenu;
        this.updateStatMenuOrSubMenu({type, value});
        this.fetchSubMenus()
      } catch (error) {
        if (error.response?.data?.code == 400) {
          error.response.data.data.forEach((v) => {
            this.modal.errorMessage[v.path] = v.msg
          })
        }
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        if (this.table.search !== this.$route.query.search) {
          this.$router.push({ name: 'Sub Menu', params: { moduleSlug: 'material-management' }, query: this.table.search ? { search: this.table.search } : null, });
          this.fetchSubMenus();
        }
      }, 500);
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },
    onPageChanged(page) {
      this.currentPage = page;
    },
  },
};
</script>

<style scoped></style>
